import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Empleado } from 'src/app/administracion/modelos/empleado';
import { UsuarioService } from 'src/app/administracion/servicios';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicioUsuario } from 'src/app/administracion/modelos/Control_Usuario/servicio-usuario';
import { ServicioUsuarioService } from 'src/app/administracion/servicios/Control_Usuario/servicio-usuario.service';
import { Perfil } from 'src/app/administracion/modelos/perfil';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { DocumentosService } from 'src/app/administracion/servicios/documentos.service';

@Component({
  selector: 'app-responsiva-servicio',
  templateUrl: './responsiva-servicio.component.html',
  styleUrls: ['./responsiva-servicio.component.scss'],
})
export class ResponsivaServicioComponent implements OnInit {
  /**Campos para la Responsiva */
  idSolicitud: number = 0;
  serUsuario: ServicioUsuario = new ServicioUsuario();
  colaborador: Empleado = new Empleado();
  administrador: Empleado = new Empleado();
  solicitaSimbanck = false;
  serUsuSimbank: ServicioUsuario = new ServicioUsuario();

  /**Form Control del que suscribe */
  colaboradorFilter = new FormControl();

  suscriptor: Empleado = new Empleado();

  fecha: string = '';
  dataSourcePDF = new MatTableDataSource<string[]>([]);
  dataSource = new MatTableDataSource<ServicioUsuario>([]);
  listaColaboradores: Empleado[] = [];

  private _listaCargo: Perfil[] = [];
  listaCargos: Perfil[] = [];
  listaMeses: string[] = [
    ' DE ENERO DE ',
    ' DE FEBRERO DE ',
    ' DE MARZO DE ',
    ' DE ABRIL DE ',
    ' DE MAYO DE ',
    ' DE JUNIO DE ',
    ' DE JULIO DE ',
    ' DE AGOSTO DE ',
    ' DE SEPTIEMBRE DE ',
    ' DE OCTUBRE DE ',
    ' DE NOVIEMBRE DE ',
    ' DE DICIEMBRE DE ',
    'ERROR',
  ];
  descargando = false;

  constructor(
    private servicioUsuarioService: ServicioUsuarioService,
    private usuarioService: UsuarioService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private readonly documentosService: DocumentosService
  ) {}

  /**Formulario para los datos del que suscribe */
  formResponsiva = this.formBuilder.group({
    puesto_suscribe: ['', [Validators.required]],
  });

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.idSolicitud = params['idSolicitud'];
      this.parametros();
    });

    let fechaAct: Date = new Date();
    /**Asigna la fecha actual con el formato correcto a la variable */
    this.fecha =
      fechaAct.toISOString().substring(8, 10) +
      ' ' +
      this.listaMeses[Number(fechaAct.toISOString().substring(5, 7)) - 1] +
      ' ' +
      fechaAct.toISOString().substring(0, 4);
  }

  /**Captura el id de la solicitud recibida y se asignan los valores correspondientes al empleado */
  parametros() {
    let listaSE: ServicioUsuario[] = [];
    let listaStSE: string[][] = [];

    this.servicioUsuarioService
      .todosLosServiciosUsuarioPorSolicitudId(this.idSolicitud)
      .subscribe((servicios) => {
        servicios.forEach((servicio) => {
          this.serUsuario = servicio;
          let sucursalCo = ''; //this.colaborador.sucursal?.nombreSucursal+"";//this.serUsuario.nomSucursalCol+"";
          //Obtiene todos los detalles de la solicitud, es decir los servicios que contiene la solicitud

          /**Se hace mension de que la solicitud incluye "SIMBANK" ya que esto conlleva a que se genere una carta responsiva */
          if (
            this.serUsuario.detalleSolicitud.tipo_servicio.nombre_servicio?.includes(
              'SIMBANK'
            )
          ) {
            this.solicitaSimbanck = true;
            this.serUsuSimbank = this.serUsuario;
          }

          this.usuarioService
            .getAnEmpleado(
              Number(this.serUsuario.detalleSolicitud.solicitud.colaboradorId)
            )
            .subscribe((val) => {
              this.colaborador = val;
              this.serUsuario.nomSucursalCol = val?.sucursal?.nombreSucursal;
              sucursalCo = val?.sucursal?.nombreSucursal + '';
            });

          this.usuarioService
            .getAnEmpleado(
              Number(
                this.serUsuario.detalleSolicitud.solicitud.administrador_TI_id
              )
            )
            .subscribe((val) => {
              this.administrador = val;
            });

          let sistema =
            this.serUsuario.detalleSolicitud.tipo_servicio.nombre_servicio + '';
          let usuario = this.serUsuario.usuario + '';
          let contrasenia = this.serUsuario.contrasenia + '';
          listaSE.push(this.serUsuario);
          listaStSE.push([sistema, usuario, contrasenia]); //this.serUsuario.nomSucursalCol+""
          this.dataSource.data = listaSE;
          this.dataSourcePDF.data = listaStSE;
        });
      });

    /**Llena la lista de puestos*/
    this.usuarioService.getAllPuesto().subscribe((val) => {
      this._listaCargo = val;
      this.listaCargos = [...this._listaCargo];
    });
  }

  /**Llena la lista de colaboradores */
  buscarEmpleado(nombre: string) {
    if (nombre.trim() === '') {
      this.listaColaboradores = [];
      return;
    }

    //this.listaColaboradores.splice(0,this.listaColaboradores.length);
    this.usuarioService.getAllEmpleadosNombre(nombre).subscribe((val) => {
      val.forEach((emp) => {
        emp.nomb_compl =
          emp.nombre + ' ' + emp.apellidoPat + ' ' + emp.apellidoMat;
      });
      this.listaColaboradores = val;
    });
  }

  buscarPuesto(term: string) {
    if (term.trim() === '') {
      this.listaCargos = [...this._listaCargo];
      return;
    }

    this.listaCargos = this._listaCargo.filter((cargo) => {
      return cargo.nombrePuesto?.toLowerCase().includes(term.toLowerCase());
    });
  }

  /**Cargar datos del colaborador */
  cargarDatosSuscribe(event: any) {
    this.suscriptor = this.colaboradorFilter.value;
  }

  /**Permite habilitar el boton para enviar la solicitud, solo si ya se ha elegido al que sustituye */
  habilitarBotonResponsiva() {
    if (this.colaboradorFilter.value != null) {
      return true;
    }
    return false;
  }

  descargarResponsiva() {
    this.descargando = true;

    this.documentosService
      .descargarDocumento(
        `RESPONSIVA ${this.colaborador.nombre} ${
          this.colaborador.apellidoPat
        } ${this.colaborador.apellidoMat || ''}`,
        {
          archivo: 'responsiva_servicio',
          data: {
            colaborador: `${this.colaborador.nombre} ${
              this.colaborador.apellidoPat
            } ${this.colaborador.apellidoMat || ''}`,
            colaboradorSuscribe: this.suscriptor.nomb_compl,
            fecha: this.fecha,
            puestoSuscribe: this.formResponsiva.value.puesto_suscribe,
            data: this.dataSourcePDF.data,
          },
        }
      )
      .subscribe({
        next: () => {
          this.descargando = false;
        },
        error: (error) => {
          this.descargando = false;
        },
      });
  }

  descargarCartaResponsiva() {
    this.descargando = true;

    this.documentosService
      .descargarDocumento(
        `CARTA RESPONSIVA ${this.colaborador.nombre} ${
          this.colaborador.apellidoPat
        } ${this.colaborador.apellidoMat || ''}`,
        {
          archivo: 'carta_responsiva_servicio',
          data: {
            nombreServicio:
              this.serUsuSimbank.detalleSolicitud.tipo_servicio.nombre_servicio,
            colaborador: `${this.colaborador.nombre} ${
              this.colaborador.apellidoPat
            } ${this.colaborador.apellidoMat || ''}`,
            sucursal: this.colaborador.sucursal?.nombreSucursal,
            calle: this.colaborador?.sucursal?.calle,
            numero: this.colaborador?.sucursal?.numero,
            colonia: this.colaborador?.sucursal?.colonia,
            municipio: this.colaborador?.sucursal?.municipio,
            estado: this.colaborador?.sucursal?.estado,
            codigoPostal: this.colaborador?.sucursal?.codigoPostal,
            puestoColaborador: this.colaborador?.puesto?.nombrePuesto,
            usuario: this.serUsuSimbank.usuario,
            contrasenia: this.serUsuSimbank.contrasenia,
            fecha: this.fecha,
          },
        }
      )
      .subscribe({
        next: () => {
          this.descargando = false;
        },
        error: (error) => {
          this.descargando = false;
        },
      });
  }

  /**Permite regresar al seguimiento */
  regresar() {
    this.router.navigate(['layout/SeguimientoControlU']);
  }
}
